// Campo reutilizable "¿Tienes un código?" con validación en servidor.
// Modo vista previa: si recibe `params` (horario_id / bono_tipo_id / evento_slug)
// muestra el descuento; si no, solo captura el texto.
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Tag, Check, Loader2, X } from 'lucide-react';
import { validarCodigo, ApiError } from '../lib/api';

export function formatEur(n, lang) {
  return new Intl.NumberFormat(lang || 'es', { style: 'currency', currency: 'EUR' }).format(Number(n) || 0);
}

export default function CodigoDescuento({ ambito, params, email, token, onChange, disabled, preview = true }) {
  const { t, i18n } = useTranslation();
  const lang = (i18n.resolvedLanguage || 'es').toLowerCase();
  const [abierto, setAbierto] = useState(false);
  const [valor, setValor] = useState('');
  const [res, setRes] = useState(null);
  const [error, setError] = useState(null);
  const [cargando, setCargando] = useState(false);
  const clave = JSON.stringify(params || {});

  // Si cambia el producto, el resultado anterior deja de valer.
  useEffect(() => {
    setRes(null); setError(null);
    onChange?.(valor.trim() ? { codigo: valor.trim(), validado: false } : null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clave]);

  const aplicar = async () => {
    const codigo = valor.trim();
    if (!codigo) return;
    setError(null);
    if (!preview) { onChange?.({ codigo, validado: false }); return; }
    setCargando(true);
    try {
      const r = await validarCodigo({ codigo, ambito, ...params, email: email || undefined }, token);
      setRes(r);
      onChange?.({ codigo: r.codigo, validado: true, ...r });
    } catch (e) {
      setRes(null);
      onChange?.(null);
      const c = e instanceof ApiError ? e.code : null;
      setError(t('codigo.errores.' + c, { defaultValue: (e && e.message) || t('codigo.errores.generico') }));
    } finally { setCargando(false); }
  };

  const quitar = () => { setValor(''); setRes(null); setError(null); onChange?.(null); };

  if (!abierto && !valor) {
    return (
      <button type="button" className="codigo-toggle" onClick={() => setAbierto(true)} disabled={disabled}>
        <Tag size={14} strokeWidth={1.5} /> {t('codigo.tengo')}
      </button>
    );
  }
  return (
    <div className="codigo-box">
      <label className="codigo-label">{t('codigo.label')}</label>
      <div className="codigo-fila">
        <input
          type="text" value={valor} maxLength={40} disabled={disabled || (!!res && preview)}
          onChange={(e) => { setValor(e.target.value.toUpperCase()); setRes(null); setError(null); onChange?.(e.target.value.trim() ? { codigo: e.target.value.trim(), validado: false } : null); }}
          onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); aplicar(); } }}
          placeholder={t('codigo.placeholder')}
        />
        {res ? (
          <button type="button" className="btn-ghost codigo-btn" onClick={quitar} disabled={disabled}><X size={14} /> {t('codigo.quitar')}</button>
        ) : (
          <button type="button" className="btn-ghost codigo-btn" onClick={aplicar} disabled={disabled || cargando || !valor.trim()}>
            {cargando ? <Loader2 size={14} className="spin" /> : t('codigo.aplicar')}
          </button>
        )}
      </div>
      {res && (
        <div className="codigo-ok">
          <Check size={14} strokeWidth={2} />
          <span>
            {t('codigo.aplicado', { descuento: formatEur(res.descuento_euros, lang) })}{' '}
            <strong>{t('codigo.total', { total: formatEur(res.total_euros, lang) })}</strong>
            {res.saldo_restante_euros != null && ` · ${t('codigo.saldo_restante', { saldo: formatEur(res.saldo_restante_euros, lang) })}`}
          </span>
        </div>
      )}
      {error && <div className="codigo-error">{error}</div>}
    </div>
  );
}
